import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapGetters('tradingArea', ['trading_areas']),
    },

    methods: {
        ...mapActions('tradingArea', ['getTradingAreaListIfNecessary']),

        refreshTradingAreaList: _.debounce(function(query) {
            this.getTradingAreaListIfNecessary({ query: query });
        }, 500),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/trading_area.js